<div *ngIf="open && variant === 'inline'" class="ss-inline-confirm ss-inline-confirm--{{ tone }}" role="alertdialog" aria-live="assertive" [attr.aria-label]="title">
  <div class="ss-inline-confirm__text">
    <strong class="ss-inline-confirm__title">{{ title }}</strong>
    <p *ngIf="message" class="ss-inline-confirm__message">{{ message }}</p>
    <ng-content></ng-content>
  </div>
  <div class="ss-inline-confirm__actions">
    <button type="button" class="ss-btn outline-primary" data-cancel (click)="cancelled.emit()" [disabled]="loading">{{ cancelLabel }}</button>
    <button type="button" class="ss-btn" [ngClass]="tone === 'danger' ? 'danger-solid' : 'primary'" (click)="confirm()" [disabled]="loading" [attr.aria-busy]="loading">
      <lucide-icon *ngIf="loading" name="loader-circle" [size]="16" class="animate-spin" aria-hidden="true"></lucide-icon>
      {{ confirmLabel }}
    </button>
  </div>
</div>

<ss-dialog *ngIf="variant === 'modal'" [open]="open" [title]="title" [tone]="tone === 'danger' ? 'danger' : tone === 'warning' ? 'warning' : 'default'" size="sm" [busy]="loading" (closed)="cancelled.emit()">
  <p *ngIf="message" class="ss-inline-confirm__message">{{ message }}</p>
  <ng-content></ng-content>
  <div ssDialogActions>
    <button type="button" class="ss-btn outline-primary" data-cancel (click)="cancelled.emit()" [disabled]="loading">{{ cancelLabel }}</button>
    <button type="button" class="ss-btn" [ngClass]="tone === 'danger' ? 'danger-solid' : 'primary'" (click)="confirm()" [disabled]="loading" [attr.aria-busy]="loading">
      <lucide-icon *ngIf="loading" name="loader-circle" [size]="16" class="animate-spin" aria-hidden="true"></lucide-icon>
      {{ confirmLabel }}
    </button>
  </div>
</ss-dialog>
